<div class="modal-header">
  <h2>{{ title || ('metadata.metadata_analysis_summary' | translate) }}</h2>
  <button (click)="close()">✕</button>
</div>

<div class="ai-analysis-container">
  <div *ngIf="isLoading || streamingState.isTranslating" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ analysisType == 'stylometric' ? 'Analyzing stylometric data...' : (isLoading ? ('metadata.analyzing_metadata' | translate) : ('metadata.translating_content' | translate)) }}</p>
  </div>

  <ng-container *ngIf="!isLoading && !streamingState.isTranslating">
    <div class="summary-text">
      <p>{{ streamingState.analysisSummary }}</p>
    </div>

    <div class="flags-section" *ngIf="streamingState.showFlags">
      <h3 class="section-title" style="text-transform: uppercase;">{{ 'metadata.flags_identified' | translate }}</h3>
      <table class="flags-table">
        <thead>
          <tr>
            <th style="text-transform: uppercase;">{{ 'new_entries.flags' | translate }}</th>
            <th style="text-transform: uppercase;">{{ 'new_entries.details' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let flag of streamingState.currentFlags">
            <th scope="row" class="flag-column">{{ flag.flag }}</th>
            <td>{{ flag.details }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div class="close-button-container">
    <button class="close-button" [disabled]="streamingState.isStreaming || streamingState.isTranslating" (click)="close()">{{ 'general.close' | translate }}</button>
  </div>
</div>
